import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import PostLink from "../components/post-link"
import SEO from "../components/seo"

const Posts = edges => {
  const Posts = edges
    .filter(edge => !!edge.node.frontmatter.date) // You can filter your posts based on some criteria
    .map(edge => <PostLink key={edge.node.id} post={edge.node} />)

  return <div>{Posts}</div>
}

const IndexPage = ({
  data: {
    allMarkdownRemark: { edges }
  }
}) => (
  <Layout>
    <div className="max-w-4xl pt-4 mx-auto">
      <div className="max-w-xl">
        <SEO title="Blog" />
        <h1 className="mb-8 font-semibold text-black">
          Blog
        </h1>
        <div className="text-lg mb-8 md:mb-24 leading-snug text-gray-800">
          {Posts(edges)}
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
export const pageQuery = graphql`
  query {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          excerpt(pruneLength: 250)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            path
            title
          }
        }
      }
    }
  }
`